import React, {Component} from 'react';
import styled from 'styled-components';
import {brk, theme} from "../styles/constants";
import ImageTyped from "./ImageTyped";


const Container = styled.div`
    background-color: ${theme.lightGrey};
    display : flex;
    justify-content:center;
    
    @media (max-width : ${brk.S}) {
        flex-wrap: wrap;
    }
    
`;

const Client = styled.div`
    width : 30%;
    
    @media (max-width : ${brk.S}) {
       width : calc(100% / 3);
    }
   
`;





class SliderImageSmall extends Component {
    render() {
        const {
            slider
        } = this.props;

        return (
            <Container >
                {

                    slider.map((image, i) =>
                        <Client><ImageTyped dataImage={image} key={i}/></Client>
                    )

                }

            </Container>
        )
    }
}


export default SliderImageSmall;